import React from 'react';
import { appContext } from '../../util/decorators';
import VButton from '../VButton.jsx';
import SocialArea from './SocialArea.jsx';
import TranslatedLink from '../TranslatedLink.jsx';
import StickyUnderNav from './StickyUnderNav';
import FeedbackWidget from 'component/Feedback/FeedbackWidget';

@appContext
export default class UserArea extends React.PureComponent {
  render() {
    const t = this.context.app.t;

    return (
      <StickyUnderNav>
        <div className="user-area">
          <FeedbackWidget className="feedback-widget"/>
          <i className="icon-avatar"></i>
          <p>{t('UserArea.login_blurb')}</p>
          <TranslatedLink name="Login" className="login-link">
            <VButton type="primary" small elementType="div">{t('UserArea.login')}</VButton>
          </TranslatedLink>
          <SocialArea />
        </div>
      </StickyUnderNav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Sidebar/UserArea.jsx